"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _reactFeather = require("react-feather");
var _helpers = require("../../utils/helpers");
var _settings = require("../../settings");
var _ModalContainerModule = _interopRequireDefault(require("./../../scss/layout-wrappers/ModalContainer.module.scss"));
/**
 * creates a new div in which to place the modal/dialog
 */
const createPortalElement = modalId => {
  const check = document.querySelector(`#${modalId}`);
  if (!check) {
    const modalDiv = document.createElement('div');
    modalDiv.setAttribute('id', modalId);
    document.querySelector('body').append(modalDiv);
  }
};
function ModalContainer({
  contentComponent = 'BCVideoPlayer',
  airaLabel = '',
  modalId = 'modal-container',
  onModalClose = () => true,
  children
}) {
  const [Layout, setLayout] = (0, _react.useState)(null);
  const [state, setState] = (0, _react.useState)('entering');
  const [containerClosing, setContainerClosing] = (0, _react.useState)(false);
  const [contentComponentProps, setContentComponentProps] = (0, _react.useState)(null);
  const [forceOpen, setForceOpen] = (0, _react.useState)(false);
  //Todo: use for returning focus to the element that opened the modal
  //const [returnFocusEl, setReturnFocusEl] = useState(null)
  const dialogRef = (0, _react.useRef)(null);
  /**
   * runs the closing animation prior to 
   * closing the dialog
   */
  const initiateClose = () => {
    setState('exiting');
    setContainerClosing(true);
    if (dialogRef.current !== null) setTimeout(() => {
      dialogRef.current.close();
      setContainerClosing(false);
      setState('entering');
      onModalClose();
    }, 750);
  };
  /**
   * handles any key down, up, or press event
   * @param {SyntheticEvent} e 
   */
  const handleKeyPress = e => {
    // if the Escape key was pressed and the dialog is open then close it
    if ([...dialogRef.current.attributes].findIndex(item => item.name === "open") !== -1) {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        initiateClose();
      }
    }
  };
  /**
   * if the backdrop of the dialog is clicked 
   * close the dialog
   * 
   * @param {SyntheticEvent} e 
   */
  const handleClick = e => {
    if (e.target.classList.contains(`${_ModalContainerModule.default['modal']}`)) initiateClose();
  };
  createPortalElement(modalId);

  /**
   * load the layout component for this modal
   */
  (0, _react.useEffect)(() => {
    document.getElementById(modalId).removeEventListener(`scripps:${modalId.replaceAll('-', '')}:change`, e => {
      setContentComponentProps(e.detail.componentProps);
      if (e.detail.forceOpen) setForceOpen(prev => !prev);
    });
    // load the layout component used for this modal
    async function loadLayout() {
      setLayout(_settings.blockLayoutsMap.get(contentComponent));
    }
    if (contentComponent !== '') loadLayout();
    document.getElementById(modalId).addEventListener(`scripps:${modalId.replaceAll('-', '')}:change`, e => {
      setContentComponentProps(e.detail.componentProps);
      if (e.detail.forceOpen) setForceOpen(prev => !prev);
    });
    return () => {
      document.getElementById(modalId).removeEventListener(`scripps:${modalId.replaceAll('-', '')}:change`, e => {
        setContentComponentProps(e.detail.componentProps);
        if (e.detail.forceOpen) setForceOpen(prev => !prev);
      });
    };
  }, [contentComponent, modalId]);

  /**
   * once the layout is loaded set the
   * dialog reference 
   */
  (0, _react.useEffect)(() => {
    let localDialogRef = null;

    /**
     * wait for dialogRef to be available before 
     * setting the value
     */
    const pollForDialogRef = () => {
      const refresh = setInterval(() => {
        if (dialogRef.current !== null) {
          localDialogRef = dialogRef.current;
          clearInterval(refresh);
        }
      }, 100);
    };
    if (dialogRef.current === null) pollForDialogRef();
    return () => {
      var _localDialogRef;
      (_localDialogRef = localDialogRef) === null || _localDialogRef === void 0 ? void 0 : _localDialogRef.close();
    };
  }, [Layout]);

  /**
   * when props or forceOpen changes open the
   * modal if it's not already open
   */
  (0, _react.useEffect)(() => {
    var _dialogRef$current;
    // check that dialog element doesn't have the attribute "open" (it's not already open) and that contentComponentProps is not null
    if ([...dialogRef.current.attributes].findIndex(item => item.name === "open") === -1 && contentComponentProps !== null) (_dialogRef$current = dialogRef.current) === null || _dialogRef$current === void 0 ? void 0 : _dialogRef$current.showModal();
  }, [contentComponentProps, forceOpen]);
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(_react.Suspense, null, /*#__PURE__*/_react.default.createElement("dialog", {
    ref: dialogRef,
    "data-state": state,
    className: (0, _helpers.classes)([_ModalContainerModule.default['modal'], 'modal']),
    onKeyDown: handleKeyPress,
    onKeyUp: handleKeyPress,
    onClick: handleClick,
    onCancel: e => e.preventDefault(),
    "aria-modal": "true",
    "aria-label": airaLabel
  }, Layout !== null && children === undefined && /*#__PURE__*/_react.default.createElement(Layout, (0, _extends2.default)({}, contentComponentProps, {
    containerClosing: containerClosing,
    handleClosing: handleKeyPress
  })), children !== undefined && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _react.default.Children.map(children, child => {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      ...contentComponentProps,
      containerClosing: containerClosing,
      handleClosing: handleKeyPress
    });
  })), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: initiateClose,
    className: (0, _helpers.classes)([_ModalContainerModule.default['modal__close-btn'], 'modal__close-btn']),
    "aria-label": "Close"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "close"), /*#__PURE__*/_react.default.createElement("i", null, /*#__PURE__*/_react.default.createElement(_reactFeather.X, {
    width: "48",
    height: "48"
  }))))), document.getElementById(modalId));
}
var _default = exports.default = ModalContainer;